import { Button, ClickEvent, TableSelectionEvent } from "@mcleod/components";
import { AutogenLayoutDistanceRateTableList } from "./autogen/AutogenLayoutDistanceRateTableList";
import { CopyDistanceRateTable } from "./CopyDistanceRateTable";

export class DistanceRateTableList extends AutogenLayoutDistanceRateTableList {

    onLoad(): void | Promise<void> {
       const buttonDelete = this.tableDistanceRateTables.headingPanel["panelStandardLeftTools"]["buttonDelete"].get();
         if (buttonDelete) {
            buttonDelete.visible = false;
         }
    }

    tableDistanceRateTablesOnSelect(event: TableSelectionEvent) {
        this.buttonCopy.enabled = this.tableDistanceRateTables.hasSelection;
    }

    async buttonCopyOnClick(event: ClickEvent) {
        const selected = this.tableDistanceRateTables.selectedRow;
        if (selected) {
            const sourceId = selected.data.getString("id");
            return CopyDistanceRateTable.showModal(sourceId).then(() => this.mainDataSource.search());
        }
    }

}